import { useState, useEffect, useRef } from "react";
import { useLanguage } from "../contexts/LanguageContext";
import MenuIcon from "./icons/MenuIcon.svg";
import PolishFlag from "./icons/PolishFlag.svg";
import UKFlag from "./icons/UKFlag.svg";

function Header({name, navLinks, isScrolled, currentRoute}) {
  const { language, toggleLanguage, t } = useLanguage();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const headerClasses = `fixed top-0 left-0 right-0 z-20 transition-all duration-300 ${
    isScrolled ? "bg-black/80 backdrop-blur-md" : "bg-black/30 backdrop-blur-sm"
  }`;

  const navClasses = `flex items-center justify-between transition-all duration-300 ${
    isScrolled ? "h-16" : "h-20"
  }`;

  return (
    <header className={headerClasses}>
      <nav className="container mx-auto px-6 sm:px-8 lg:px-12">
        <div className={navClasses}>
          <a
            href="#"
            className="text-3xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-purple-500 to-cyan-500 hover:opacity-80 transition-opacity"
          >
            {name}
          </a>

          <div className="flex items-center space-x-4">
            {/* Language Switch */}
            <button
              onClick={toggleLanguage}
              className="flex items-center space-x-2 px-3 py-1 rounded-full bg-gray-800/50 border border-white/10 hover:bg-gray-700/50 transition-colors"
              aria-label="Toggle language"
            >
              <span className="text-sm font-medium">{language === 'pl' ? 'PL' : 'ENG'}</span>
              <img src={language === 'pl' ? PolishFlag : UKFlag} className="w-4 h-3" alt={language === 'pl' ? 'Polish flag' : 'UK flag'} />
            </button>

            <div className="relative" ref={menuRef}>
              <button
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                className="p-2 rounded-md text-gray-300 hover:text-white hover:bg-white/10 focus:outline-none focus:ring-2 focus:ring-purple-500"
                aria-label="Open navigation menu"
                aria-expanded={isMenuOpen}
              >
                <img src={MenuIcon} className="w-6 h-6" style={{color:"white"}} alt="Menu icon"/>
              </button>

              {isMenuOpen && (
                <div className="absolute right-0 mt-2 w-48 bg-gray-900/90 backdrop-blur-lg rounded-md shadow-lg border border-white/10 origin-top-right animate-fade-in-dropdown">
                  <div
                    className="py-1"
                    role="menu"
                    aria-orientation="vertical"
                    aria-labelledby="options-menu"
                  >
                    <a
                      href="#"
                      onClick={() => setIsMenuOpen(false)}
                      className={`block px-4 py-2 text-sm text-gray-300 hover:bg-purple-500/20 hover:text-white transition-colors ${
                        currentRoute === "#" || currentRoute === ""
                          ? "nav-link-active"
                          : ""
                      }`}
                      role="menuitem"
                    >
                      {t('home')}
                    </a>
                    {navLinks.map((link) => (
                      <a
                        key={link.label}
                        href={link.url}
                        onClick={() => setIsMenuOpen(false)}
                        className={`block px-4 py-2 text-sm text-gray-300 hover:bg-purple-500/20 hover:text-white transition-colors ${
                          currentRoute === link.url ? "nav-link-active" : ""
                        }`}
                        role="menuitem"
                      >
                        {link.label}
                      </a>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </nav>
    </header>
  );
}

export default Header;
